<template>
  <div class="home-view">
    <Topbar />

    <div class="container-fluid" style="padding-top: 90px">


      <div class="card w-100">
        <div class="card-header bg-primary text-white">
          <h4 class="m-0">
            HISTÓRICO FECHAMENTO <em class="fa fa-clock ml-2 mr-4"></em>
            <div v-show="carregando" class="spinner-grow">
                <span class="sr-only">Loading...</span>
            </div>
          </h4>
          
        </div>

        <div class="card-body">

          <div class="alert alert-danger" v-if="this.error">
            {{ error }}
          </div>

          <div class="card">
            <div class="card-body">
              <div class="row text-left">
                <input-and-label
                      column="4"
                      name="pesquisa"
                      label="Pesquisa"
                      v-model="filtro.pesquisa"
                      type="text"
                  />
                <SelectAndLabel column="2" name="modulo" label="Módulo" :options="options_modulos"
                  v-model="filtro.modulo" :errorMessage="errors.modulo" />
                  <input-and-label
                      column="2"
                      name="dataInicio"
                      label="Data Log Início"
                      v-model="filtro.dataInicio"
                      type="date"
                  />
                  <input-and-label
                      column="2"
                      name="dataFim"
                      label="Data Log Fim"
                      v-model="filtro.dataFim"
                      type="date"
                  />
                <div class="col-md-2 pt-2">
                  <br>
                  <button class="btn btn-primary" @click="list()">
                    Buscar
                    <em class="fa fa-search ml-2"></em>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="card mt-3">
            <div class="card-body table-responsive">
              <DataTable :data="logs" :columns="colunas" :sortcolumn="0" sort="desc"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LogoutModal />
    <Sidebar />
  </div>
</template>

<script>
// @ is an alias to /src
import Topbar from '@/components/Topbar.vue'
import Sidebar from '@/components/Sidebar.vue'
import LogoutModal from '@/components/LogoutModal.vue'
import SelectAndLabel from "../components/SelectAndLabel.vue";
import InputAndLabel from "../components/InputAndLabel.vue";
import DataTable from '@/components/DataTable.vue';
import { dateFormat, getDate } from "../utils";
import ViewMixin from './ViewMixin'
import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException, PermissaoException, ClientErrorException } from '../services/exceptions'
import api from '../services/api'

export default {
  name: 'Historico',
  mixins: [
    ViewMixin
  ],
  components: {
    Topbar,
    Sidebar,
    LogoutModal,
    SelectAndLabel,
    DataTable,
    InputAndLabel,
  },

  data: function () {
    return {
      baseUrl: "historico",
      error: null,
      dados: [],
      modulos: [],

      filtro: {
        pesquisa: "",
        modulo: "",
        dataInicio: "",
        dataFim: "",
      },

      options_modulos: [],
      logs: [
      ],
      colunas: [
        { label: '#', field: 'idLog_fechamento', align: 'left' },
        { label: 'Módulo', field: 'modulo', align: 'left' },
        { label: 'Data', field: 'datadaravaco', align: 'left' },
        { label: 'Usuário', field: 'usuario', align: 'left' },
        { label: 'Descrição', field: 'descricao', align: 'left' },
      ]
    }
  },

  async mounted() {

    await this.getModulos();

    this.populateFilterFromQueryString();

    (this.filtro.pesquisa = this.filtro.pesquisa ?? "");
    (this.filtro.dataInicio = this.filtro.dataInicio ?? getDate("firstDayOfLastMonth"));
    (this.filtro.dataFim = this.filtro.dataFim ?? getDate("lastDayOfMonth"));
    (this.filtro.modulo = this.filtro.modulo ?? "");

    try {
      await this.validarToken();
      await this.list();
    } catch (e) {
      if (e instanceof TokenInvalidoException) {
        this.handleTokenInvalidoException();
      } else if (e instanceof ServerErrorException) {
        alert(e.message);
      } else {
        alert(DEFAULT_ERROR_MESSAGE);
      }
    }
  },

  methods: {

    dateFormat,
    getDate,

    async validarToken() {
      this.carregando = true;

      await api.get("/validar-token");

      this.carregando = false;
    },

    async list() {
      this.carregando = true;

      try {
        let { baseUrl, filtro } = this;
        let params = {
          ...filtro
        };

        let response = await api.get(`/${baseUrl}`, { params });
        this.dados = response.data.dados;
        
        if (this.dados.length === 0) {
          this.logs = [];
        }

        for (const item of this.dados) {
          this.logs.push({
            idLog_fechamento: item.idlog_fechamento, 
            modulo: item.modulo, 
            usuario: item.nome,
            datadaravaco: dateFormat(item.datagravacao), 
            descricao: item.descricao
          });
        }

        this.changeURL(`/${this.baseUrl}?${this.encodeQueryData(params)}`);
      } catch (e) {
        if (e instanceof TokenInvalidoException) {
          this.handleTokenInvalidoException();
        } else if (e instanceof PermissaoException) {
          this.handlePermissaoException();
        } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
          alert(e.message);
        } else {
          alert(DEFAULT_ERROR_MESSAGE);
        }
      }

      this.carregando = false;
    },

    async getModulos() {
      this.carregando = true;

      try {
        let { baseUrl } = this;

        let response = await api.get(`/${baseUrl}/modulos`);
        this.modulos = response.data.dados;

        for (const item of this.modulos) {
          this.options_modulos.push({ 'name': item.nome, 'id': item.controller });
        }
      
      } catch (e) {
        if (e instanceof TokenInvalidoException) {
          this.handleTokenInvalidoException();
        } else if (e instanceof PermissaoException) {
          this.handlePermissaoException();
        } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
          alert(e.message);
        } else {
          alert(DEFAULT_ERROR_MESSAGE);
        }
      }

      this.carregando = false;
    },
  }
}
</script>

<style scoped lang="scss">
.home-view {
  height: 100%;
}

.container-img {
  display: flex;
  justify-content: center;
  align-self: center;

  background-color: rgb(233, 233, 233) !important;
  height: 100%;
}
</style>